export * from './telemetry.component';
